import { Link } from "react-router-dom";
import { Performance } from "@/data/performances";
import { ArrowUpRight } from "lucide-react";

interface OfferCardProps {
  performance: Performance;
}

const cardImages: Record<string, string> = {
  "stand-up-comedy": "https://images.unsplash.com/photo-1585699324551-f6c309eedeca?w=600&q=80&auto=format&fit=crop",
  "kabaret": "https://images.unsplash.com/photo-1507676184212-d03ab07a01bf?w=600&q=80&auto=format&fit=crop",
  "iluzjonista": "/images/iluzjonista.jpg",
  "teatr-improwizacji": "https://images.unsplash.com/photo-1503095396549-807759245b35?w=600&q=80&auto=format&fit=crop",
  "muzyka-na-zywo": "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=600&q=80&auto=format&fit=crop",
  "dj-i-wodzirej": "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=600&q=80&auto=format&fit=crop",
  "pokazy-taneczne": "https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=600&q=80&auto=format&fit=crop",
  "akrobaci": "/images/taniec/akrobaci-card.jpg",
  "pokazy-swietlne": "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=600&q=80&auto=format&fit=crop",
  "mimowie": "/images/mimowie.jpg",
  "bubble-show": "/images/bubble-show.jpg",
  "fireshow": "/images/fireshow.jpg",
  "karykaturzysta": "/images/karykaturzysta.jpg",
  "pokazy-laserowe": "/images/pokazy-laserowe.jpg",
  "wystepy-wokalne": "/images/wystepy-wokalne.jpg",
  "pokazy-barmanskie": "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?w=600&q=80&auto=format&fit=crop",
  "teatr-cieni": "/images/teatr-cieni.jpg",
  "pokazy-naukowe": "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=600&q=80&auto=format&fit=crop",
  "zonglerzy": "/images/zonglerzy.jpg",
  "pokazy-multimedialne": "/images/pokazy-multimedialne.jpg",
  "wystepy-operowe": "https://images.unsplash.com/photo-1580809361436-42a7ec204889?w=600&q=80&auto=format&fit=crop",
  "pokazy-mody": "/images/pokazy-mody.jpg",
  "warsztaty-artystyczne": "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=600&q=80&auto=format&fit=crop",
  "pokazy-kulinarne": "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&q=80&auto=format&fit=crop",
  "wystepy-orkiestrowe": "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=600&q=80&auto=format&fit=crop",
  "poetry-slam": "/images/poetry-slam.jpg",
  "pokazy-robotyki": "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=600&q=80&auto=format&fit=crop",
  "wystepy-folklorystyczne": "/images/wystepy-folklorystyczne.jpg",
  "pokazy-ekologiczne": "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&q=80&auto=format&fit=crop",
  "wystepy-beatboxerow": "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&q=80&auto=format&fit=crop",
  "wystepy-jazzowe": "/images/wystepy-jazzowe.jpg",
  "pokazy-sztuki-cyfrowej": "https://images.unsplash.com/photo-1550745165-9bc0b252726f?w=600&q=80&auto=format&fit=crop",
  "wystepy-akordeonowe": "/images/wystepy-akordeonowe.jpg",
  "pokazy-iluminacji": "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=600&q=80&auto=format&fit=crop",
  "wystepy-choralne": "/images/wystepy-choralne.jpg",
  "pokazy-bodypainting": "/images/pokazy-bodypainting.jpg",
  "wystepy-perkusyjne": "https://images.unsplash.com/photo-1524230659092-07f99a75c013?w=600&q=80&auto=format&fit=crop",
  "pokazy-pirotechniczne": "https://images.unsplash.com/photo-1498931299472-f7a63a5a1cfa?w=600&q=80&auto=format&fit=crop",
  "wystepy-skrzypcowe": "/images/wystepy-skrzypcowe.jpg",
  "pokazy-sztuki-ulicznej": "/images/pokazy-sztuki-ulicznej.jpg",
  "wystepy-gitarowe": "/images/wystepy-gitarowe.jpg",
  "pokazy-origami": "/images/pokazy-origami.jpg",
  "wystepy-harfowe": "/images/wystepy-harfowe.jpg",
  "pokazy-garncarskie": "/images/pokazy-garncarskie.jpg",
  "wystepy-fletowe": "/images/wystepy-fletowe.jpg",
  "pokazy-rzezbiarskie": "/images/pokazy-rzezbiarskie.jpg",
  "wystepy-saksofonu": "https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=600&q=80&auto=format&fit=crop",
  "pokazy-kaligrafii": "https://images.unsplash.com/photo-1455390582262-044cdead277a?w=600&q=80&auto=format&fit=crop",
  "wystepy-trabki": "https://images.unsplash.com/photo-1511192336575-5a79af67a629?w=600&q=80&auto=format&fit=crop",
  "pokazy-sztuczek-karcianych": "https://images.unsplash.com/photo-1511193311914-0346f16efe90?w=600&q=80&auto=format&fit=crop",
  "wystepy-puzonu": "/images/wystepy-puzonu.jpg",
  "pokazy-zonglerki-ogniem": "/images/pokazy-zonglerki-ogniem.jpg",
  "wystepy-wiolonczele": "/images/wystepy-wiolonczele.jpg",
  "pokazy-sztuki-kinetycznej": "/images/pokazy-sztuki-kinetycznej.jpg",
  "wystepy-kontrabasu": "/images/wystepy-kontrabasu.jpg",
  "pokazy-sztuki-swiatla": "/images/pokazy-sztuki-swiatla.jpg",
  "wystepy-ukulele": "/images/wystepy-ukulele.jpg",
  "pokazy-sztuki-papierowej": "/images/pokazy-sztuki-papierowej.jpg",
  "wystepy-mandoliny": "/images/wystepy-mandoliny.jpg",
  "pokazy-sztuki-recyklingu": "/images/pokazy-sztuki-recyklingu.jpg",
  "samba": "/images/samba.jpg",
  "salsa": "/images/salsa.jpg",
  "tango-argentynskie": "/images/tango.jpg",
  "breakdance": "/images/breakdance.jpg",
  "flamenco": "/images/flamenco.jpg",
  "balet": "/images/balet.jpg",
  "klaun-dla-dzieci": "/images/klaun-dla-dzieci.jpg",
  "magik-dla-dzieci": "/images/magik-dla-dzieci.jpg",
  "animator-dla-dzieci": "/images/animator-dla-dzieci.jpg",
  "teatr-lalek": "/images/teatr-lalek.jpg",
  "malowanie-twarzy": "/images/malowanie-twarzy.jpg",
  "modelowanie-balonow": "/images/modelowanie-balonow.jpg",
  "banki-mydlane-dzieci": "/images/banki-mydlane-dzieci.jpg",
  "maskotki": "/images/maskotki.jpg",
  "warsztaty-plastyczne-dzieci": "/images/warsztaty-plastyczne-dzieci.jpg",
  "mini-disco": "/images/mini-disco.jpg",
  "bajkowe-przedstawienia": "/images/bajkowe-przedstawienia.jpg",
  "dmuchance": "/images/dmuchance.jpg",
  "warsztaty-cyrkowe-dzieci": "/images/warsztaty-cyrkowe-dzieci.jpg",
  "musical-dla-dzieci": "/images/musical-dla-dzieci.jpg",
  "warsztaty-naukowe-dzieci": "/images/warsztaty-naukowe-dzieci.jpg",
  "fotobudka-dla-dzieci": "/images/fotobudka-dla-dzieci.jpg",
  "warsztaty-ai": "/images/warsztaty-ai.jpg",
  "pokazy-robotow": "/images/pokazy-robotow.jpg",
  "pokazy-dronow": "/images/pokazy-dronow.jpg",
  "strefa-vr": "/images/strefa-vr.jpg",
  "druk-3d": "/images/druk-3d.jpg",
  "pokazy-holograficzne": "/images/pokazy-holograficzne.jpg",
  "ai-art-show": "/images/ai-art-show.jpg",
  "robot-dance": "/images/robot-dance.jpg",
};

export const OfferCard = ({ performance }: OfferCardProps) => {
  const bgImage = cardImages[performance.slug];

  return (
    <Link to={`/atrakcje/${performance.slug}`} className="block h-full group">
      <div className="relative rounded-2xl h-[200px] overflow-hidden transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/15">
        <div 
          className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
          style={{ backgroundImage: bgImage ? `url(${bgImage})` : undefined, backgroundColor: bgImage ? undefined : 'hsl(240 6% 10%)' }}
        />
        <div className="absolute inset-0 bg-black/65 group-hover:bg-black/55 transition-colors duration-500" />

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-5 z-10">
          <h3 className="text-lg font-space-grotesk font-bold text-white mb-1.5 drop-shadow-md">
            {performance.title}
          </h3>
          <p className="text-white/75 text-xs leading-relaxed line-clamp-2 max-w-[85%]">
            {performance.description}
          </p>
        </div>

        <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 border border-white/20">
          <ArrowUpRight className="w-3.5 h-3.5 text-white" />
        </div>
      </div>
    </Link>
  );
};
